<script>
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import qs from 'query-string';
import { getPlanLogo } from '@/common/plan-logo-map';
import { BASE_PLAN_SUB_TYPES, planTypes, OPC_HREF_SYNC_QUERY_PARAMS } from '@/common/constants';
import store from '@/store/index';
import { updateHrefWithQueryParams } from '@/utils';
import { navigateCurrentWindowTo } from '@/utils/modal-utils.js';
import { plansof } from '@/utils/chain';
import base from '@/views/config/addon-cards/templates/base.vue';
import { hasZoomPhoneFreeTrialPlan } from '@/plans/ZOOM_PHONE/helper/utils';
import { translateToEn } from '@/plugins/i18n';
import { AddOnGroupTrackingUILocation, getTrackingFlowType } from '@/aspects/trackings';
import { getRecommendPlansFrom } from '@/common/product';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { $context } from '@/global-install';

export default {
  name: 'BizPlusAddOnCard',
  mixins: [base],
  for() {
    // Hide addon if user has Zoom Phone free trial plan
    if (hasZoomPhoneFreeTrialPlan()) {
      return false;
    }
    const { type, sub_type } = get(getRecommendPlansFrom(store.getters.getSelectedPlans), [0], {});
    if (
      (window.$context.is.buyNow || window.$context.is.basic2pro) &&
      !pageConfig.isFreeTrialAccount &&
      !$context.is.isFreeWinback &&
      type === planTypes.ZOOM_MEETING &&
      sub_type === BASE_PLAN_SUB_TYPES.BIZ
    ) {
      return true;
    }
    return false;
  },
  created() {
    const currentPlan = plansof(this.planMapFlat)
      .type(this.planType)
      .category('zonebizpzvu')
      .cycle('monthly')
      .get(0);
    const { amount } = currentPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [
      this.$money(amount),
    ]);
  },
  data() {
    return {
      title: this.$t('billing.planform.title.zoom_one_biz_plus'),
      trackingPlanName: translateToEn('billing.planform.title.zoom_one_biz_plus'),
      subtitle: '',
      planType: planTypes.ZOOM_ONE_BUNDLE,
      logo: getPlanLogo(planTypes.ZOOM_ONE_BUNDLE),
      description: this.$t('billing.zoom_one_pro.desc'),
      addText: this.$t('common.btn_switch_plan'),
      addTrackingText: translateToEn('common.btn_switch_plan'),
    };
  },
  computed: {
    ...mapGetters(['planMapFlat', 'getCurrentBasePlanInfo', 'couponState']),
  },
  methods: {
    // Switch to Business Plus
    addOn() {
      const currentBasePlanCode = get(
        this.getCurrentBasePlanInfo,
        'plans.0.plan_code',
      );
      this.$tracking({
        event: 'buyInteraction',
        buyInteraction: `${this.trackingBasePlanName} add-ons`,
        buySelection: `${this.trackingPlanName} - ${this.trackingAddAction}`,
        uiLocation: AddOnGroupTrackingUILocation[this.group],
        flowType: getTrackingFlowType()
      })
      const cacheTimestamp = qs.parse(location.search)._;
      const params = {
        switchFrom: `${currentBasePlanCode},${cacheTimestamp}`,
      }
      if (this.couponState.couponCode) {
        params.persistCoupon = this.couponState.couponCode;
      }
      if (this.$context.is.basic2pro) {
        params.type = flowTypes.basic2pro;
      }
      navigateCurrentWindowTo(
        updateHrefWithQueryParams(
          '/opc/buy?plan=zonebundle&from=zonebundle_zonebizpzvu&period=annual',
          OPC_HREF_SYNC_QUERY_PARAMS,
          params,
        ),
        { replace: true }
      );
    },
  },
};

</script>
